const endPoints = {
    NOTICES :'/notices',
    SPEECHES: '/speeches',
    JOURNEYS:'/journeys',
    CIRCULARS: '/circulars',
    CONTACT: '/contacts',
    APPLICANTS: '/applicants',
    PARRENT_COMPANY: '/companies/parent',

    ABOUT: (company_id :number) => `/abouts?company_id=${company_id}`,
    PHILOSOPHIES: (typ :number,company_id :number) => `/philosophies?type=${typ}&company_id=${company_id}`,
    BANNER: (typ :number) => `/banners?type=${typ}`,
    BANNER_COMPANY: (typ :number,company_id: number) => `/banners?type=${typ}&company_id=${company_id}`,
    COMMITMENTS: (page: number, limit : number) => `/commitments?per_page=${limit}&page=${page}`,
    COMPANIES: (page: number, limit : number) => `/companies?order_by=latest&page=${page}&per_page=${limit}`,
    COMPANY_PRODUCTS: (company_id: number ) => `/products?company_id=${company_id}`,
    GET_COMPANY: (slug: string ) => `/companies/${slug}`,
    DIRECTORS: (company_id: number ) => `/directors?company_id=${company_id}`,
    GET_SOCIAL: (company_id: number ) => `/socials?company_id=${company_id}`,
    GET_EVENTS: (page: number, limit : number, skip : number) => `/events?per_page=${limit}&page=${page}&skip=${skip}`,
    EVENT: (id: number ) => `/events/${id}`,
    EVENT_BY_SLUG: (slug: string ) => `/events/${slug}`,
    GET_BLOGS: (page: number, limit : number) => `/blogs?per_page=${limit}&page=${page}&is_pinned=2`,
    BLOGS: (page: number, limit : number) => `/blogs?per_page=${limit}&page=${page}&is_pinned=0`,
    GET_BLOG: (id: number ) => `/blogs/${id}`,
    BLOG_BY_SLUG: (slug: string ) => `/blogs/${slug}`,
    FAQ: (company_id: number) => `/values?company_id=${company_id}`,
}    

export default endPoints